import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { handlePostHogOpenedSharedNugget } from '@backrs_ui/grow-ui/src/pages/Prosper/pages/prosper.util';
import { useGetSuggestedPlaylistBySlugQuery } from '@backrs_ui/grow-ui/src/redux/priorities/priorities.api';
import { openSuggestedPlaylistViewStep } from '@backrs_ui/grow-ui/src/redux/priorities/priorities.slice';
import { AppDispatch } from '@backrs_ui/grow-ui/src/redux/store';

import { PostHog } from 'posthog-js';

export const usePreLinkedParams = (dispatch: AppDispatch, postHog: PostHog) => {
  const [searchParams] = useSearchParams();

  const suggestedPlaylistSlug = searchParams.get('playbook');
  const { data: suggestedPlaylist, isLoading: isLoadingSuggestedPlaylist } =
    useGetSuggestedPlaylistBySlugQuery(suggestedPlaylistSlug || '', {
      skip: !suggestedPlaylistSlug,
    });

  useEffect(() => {
    const preLinkedParams = {
      preLinkedNuggetSlug: searchParams.get('nugget'),
      preLinkedScholarshipId: searchParams.get('scholarship'),
      preLinkedCareerPathId: searchParams.get('career-path'),
      preLinkedProfileInternalId: searchParams.get('profile-in'),
      preLinkedProfileExternalId: searchParams.get('profile-ex'),
      preLinkedInternshipId: searchParams.get('internship'),
      preLinkedPostId: searchParams.get('post'),
      preLinkedGeneratedContentId: searchParams.get('generated-content'),
    } as const;

    handlePostHogOpenedSharedNugget({
      dispatch,
      postHog,
      ...preLinkedParams,
    });
  }, [dispatch, postHog, searchParams]);

  // Handle suggested playlist slug parameter
  useEffect(() => {
    if (suggestedPlaylist && !isLoadingSuggestedPlaylist) {
      dispatch(openSuggestedPlaylistViewStep(suggestedPlaylist));
    }
  }, [dispatch, suggestedPlaylist, isLoadingSuggestedPlaylist]);
};
